import { LoadingContainer, Model } from 'peach/components'
import { useParams, useRouteMatch, useHistory } from 'peach/router'
import { useClickAction } from 'peach/decorators/withActionTrigger'

import { Page } from 'core/components'
import { R } from 'core/helpers'
import { useGetWorkflowStepTypes } from 'core/types'

const WorkflowStepTypes = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const { data: workflowStepTypes, isLoading } = useGetWorkflowStepTypes({
    companyId,
  })

  useClickAction({
    label: 'Create Workflow Step Type',
    onClick: () => history.push(`${url}/create-workflow-step-type`),
  })

  const sorted = R.sortBy(workflowStepTypes ?? [], (type) => type.createdAt!)

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        <Model.List
          json={sorted}
          title='Workflow Step Types'
          withDetails
          withRelated
          withTimestamps
        />
      </Page>
    </LoadingContainer>
  )
}

export default WorkflowStepTypes
